import { AttachedProperty } from '../../../concepts/objects';
import { Audited } from '../auditing/Audited';

export const CreatedIncognitoAttr = new AttachedProperty<boolean, Audited>('incognito', false);
